<template>
  <div>
    <div class="news_page_banner_out">
      <div class="container">
        <dl class="all_page_banner_txt">
          <dt>招生就业</dt>
          <dd>recruitment &nbsp;&nbsp; employment</dd>
        </dl>
      </div>
    </div>
    <div class="container zzjg_list">
      <div class="zzjg_hd"><h3>招生就业</h3></div>
      <ul>
        <li>
          <p>
            <a
              href="https://pgzs.immu.edu.cn/"
              target="_blank"
              title="本专科生招生"
              >本专科生招生</a
            >
          </p>
        </li>
        <li>
          <p>
            <a href="http://yjsy.immu.edu.cn" target="_blank" title="研究生招生"
              >研究生招生</a
            >
          </p>
        </li>
        <li>
          <p>
            <a
              href="https://gjjyxy.immu.edu.cn/tzgg.htm"
              target="_blank"
              title="留学生招生"
              >留学生招生</a
            >
          </p>
        </li>
        <li>
          <p>
            <a href="https://immu.nmbys.cn/" target="_blank" title="就业创业"
              >就业创业</a
            >
          </p>
        </li>
      </ul>
    </div>
    <!-- <iframe
        src="../../static/zhaopin.html"
        frameborder="0"
        style="width: 100%; height: auth"
        id="bdIframe"
      ></iframe> -->
    <!-- <v-html-panel :url.asyc="html"></v-html-panel> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      html: "../../static/zhaopin.html",
    };
  },
  mounted() {
    /**
     * iframe-宽高自适应显示
     */
    const oIframe = document.getElementById("bdIframe");
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.height = Number(deviceHeight) + 1650 + "px"; //数字是页面布局高度差
  },
};
</script>
<style scoped>
.zzjg_hd h3{
    margin-top:50px;
    position: relative;
    color: #333;
    font-family: "Microsoft Yahei";
    font-weight: bold;
    text-align: left;
}
.zzjg_hd h3:before {
    position: absolute;
    left: 0px;
    bottom: -10px;
    width: 100px;
    height: 1px;
    background: #004783;
    content: "";
    z-index: 2;
}
 .zzjg_list ul {
    overflow: hidden;
    margin: 50px 0;
}
.zzjg_list ul li{
    float: left;
    border-top: 2px solid #004783;
    margin: 0 20px 30px 0;
    width: calc(33% - 30px);
    display: flex;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #e6f1fa;
    height: 88px;
    position: relative;
    text-align: center;
   
}
.zzjg_list ul li:nth-child(3n){
  margin-right: 0;
}
.zzjg_list ul li:hover {
    background: #004783;
}
.zzjg_list ul li:hover a {
    color: #FFF;
}
.zzjg_list ul li:hover p::before {
  background: url('../../static/images/icon05.png') no-repeat;;
}
 .zzjg_list ul li::before {
    position: absolute;
    width: 85px;
    height: 85px;
    right: 6px;
    top: 50%;
    margin-top: -44px;
    background: url('../../static/images/zzjg_bg_logo.png') no-repeat;
    background-size: 100% 100%;
    z-index: 3;
    content: "";
}

.zzjg_list ul li p {
    margin: 0 20px;
    display: block;
    width: 100%;
    position: relative;
    line-height: 4.6;
    height: 100%;
}
 .zzjg_list ul li p::before {
    position: absolute;
    right: 4px;
    top: 50%;
    margin-top: -6px;
    background: url('../../static/images/icon04.png') no-repeat;;
    width: 7px;
    height: 12px;
    content: "";
    z-index: 9;
}
.zzjg_list ul li p a {
    font-size: 18px;
    font-family: "Microsoft Yahei";
    padding-right: 2rem;
    display: block;
    color: #333;
}
</style>


// WEBPACK FOOTER //
// src/view/product.vue